/* eslint-disable prettier/prettier */


// ----------------------------------------------------------------------

export default function Popover({ theme }) {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: theme.shadows[25].z12
        }
      }
    }
  };
}
